<template>
  <div class="g-network-error">
    <slot></slot>

    <h3 v-if="title">{{ title }}</h3>
    <p v-if="description">{{ description }}</p>
    <div class="g-network-error-btn">
      <a-button :type="homePrimary || 'default'" @click="returnHome" v-if="home">
        {{ $t('com_btn_return_home') }}
      </a-button>

      <a-button type="primary" @click="reloadPage" v-if="reload">
        {{ $t('com_btn_reload') }}
      </a-button>

      <a-button type="primary" @click="gobackPage" v-if="goback">
        {{ $t('com_btn_back') }}
      </a-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    home: {
      type: Boolean,
      default: true,
    },
    homeClick: {
      type: [Object, Function],
      default: null,
    },
    homePrimary: {
      type: String,
      default: '',
    },
    reload: {
      type: Boolean,
      default: false,
    },
    goback: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    returnHome() {
      if (this.homeClick) {
        this.homeClick();
      } else {
        window.location.href = '/';
      }
    },
    reloadPage() {
      window.location.reload();
    },
    gobackPage() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.g-network-error {
  margin: 0 auto;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  h3 {
    color: #18181a;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }

  p {
    color: #a0a0a7;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  svg {
    width: 200px;
    height: auto;
  }

  .g-network-error-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 15px;

    button {
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
</style>
